import TranslationRepository from './TranslationRepository';

export default TranslationRepository;
